export default "__VITE_ASSET__CLEq_O67__"